
import { computed, defineComponent, nextTick, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { DateKindLabel } from '@/views/dashboard/service/_enum/date-kind'
import { countdownDay, formatTimeStamp } from '@/utils/time'
import { TerminalTypeLabel } from '@/views/dashboard/_enum/terminal-type'
import { ServiceAuthService } from '@/views/dashboard/service/_components/service-auth/service-auth.service'
import TerminalAuth from '@/views/dashboard/_components/terminal-auth/terminal-auth.vue'
import { ServiceList } from '@/views/dashboard/service/my-subscribe/my-subscribe.service'
import {
  ServiceStatus,
  ServiceStatusColor,
  ServiceStatusIcon,
  ServiceStatusLabel
} from '@/views/dashboard/service/_enum/service-status'
import { ServiceType } from '@/views/dashboard/_enum/service-type'
import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'

export default defineComponent({
  components: {
    TerminalAuth,
    CmSvgIcon,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    serviceInfo: {
      type: Object as PropType<ServiceList>,
      default: () => { return {} as ServiceList }
    },
    hideSubscribe: {
      type: Boolean,
      default: false
    },
  },

  setup (props, context) {
    const { t, locale } = useI18n()

    const drawerTitle = computed(() => {
      void locale.value
      return t('serviceAuth.configManageTitle', { name: props.serviceInfo.display_name || '' })
    })

    const injector = useReflectiveInjector([ServiceAuthService])
    const service = injector.get(ServiceAuthService)

    const terminalSelectNode = ref()
    const isLoading = ref(false)
    const terminalSelectVisible = ref(true)

    function handleClose () {
      context.emit('update:modelValue', false)
    }

    return {
      drawerTitle,
      ServiceType,
      ServiceStatus,
      ServiceStatusLabel,
      ServiceStatusColor,
      ServiceStatusIcon,
      countdownDay,
      DateKindLabel,
      TerminalTypeLabel,
      terminalSelectNode,
      isLoading,
      terminalSelectVisible,
      formatTimeStamp,
      handleClose,
    }
  }
})
